/** @format */
import React, { FC, useState, useRef, useEffect, useMemo } from 'react'
import {
  _$,
  Card,
  Input,
  FormItem,
  Form,
  Button,
  Switch,
  Message,
  Dialog,
  Radio,
  Tooltip,
  Icon
} from '@king-design/react'
import { useHistory, useLocation, useParams } from 'react-router'
import { useAsync } from 'react-use'
import ProductGroupSelect from 'src/components/ProductGroupSelect'
import {
  GetTacticsPolicyDetail,
  GetPolicyInstances,
  CreatePolicy,
  GetProductList,
  ModifyAlarmPolicy
} from 'src/api/ApiAlarmServer'
import { CustomPageContainer } from 'src/components'
import AlarmRule, { AlarmRuleHandle } from './AlarmRule'
import SelectTemplate from 'src/containers/MonitorAlarmTemplate/SelectTemplate'
import AlarmReciver, { ConcatProps, handleWayToChannels } from 'src/components/AlarmReciver/new'
import AlarmCallBack, {
  CallbackValueProp,
  handleCallbackType
} from 'src/components/AlarmCallBack/new'
import {
  TriggerRulesProps,
  initRuleItem,
  setItemSpacial,
  thanLastPeriod,
  handleMetricUnits,
  LevelValueItemProps
} from './AlarmRule/constants'
import { ProductItem } from 'src/utils/interface'
import SelectInstance, { SelectInstanceHandel } from 'src/components/SelectInstance'
import { InstanceItem } from 'src/components/SelectInstance/constants'
import { needDrop } from 'src/components/SelectInstance/SelectInstanceTabs/constants'
import AlarmCallBackTooltip from 'src/components/AlarmCallBack/Tooltip'
import RedirectPrometheus from './RedirectPrometheus'
import styled from 'styled-components'
import _ from 'lodash'
// Mbps单位的产品线
export const mbpsproduct = [111, 112, 113, 125]
interface CreateProps {
  className?: string
}
export function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const MonitorCreate: FC<CreateProps> = ({ className }) => {
  const history = useHistory()
  const params = useParams()
  // 策略名称
  const [policyName, setPolicyName] = useState<string>()
  // 产品类型
  const [currentProduct, setCurrentProduct] = useState<ProductItem>()
  // 产品类型禁用（修改或从产品列表跳转过来）
  const [productDisabled, setProductDisabled] = useState<boolean>(false)
  // 触发条件
  const [trigger, setTrigger] = useState<'rule' | 'template'>('rule')
  // 告警模版
  const [template, setTemplate] = useState<any>(undefined)
  // 告警规则
  const [alertGrading, setAlertGrading] = useState<boolean>(false)
  const [triggerRules, setTriggerRules] = useState<TriggerRulesProps[]>([initRuleItem])
  // 关联实例类型（2:项目制、3:自选、4:实例组）
  const [resourceBindType, setResourceBindType] = useState<number>(3)
  // 关联实例list
  const [instanceIds, setInstanceIds] = useState<InstanceItem[]>([])
  // 关联实例总数
  // const [instanceIdsTotal, setInstaneIdsTotal] = useState<number>(0)
  // 批量新建string
  const [IPpackage, setIPpackage] = useState<string[]>([])
  // 关联项目
  const [project, setProject] = useState<number>()
  // 是否设置为默认策略
  const [defaultPolicy, setDefaultPolict] = useState<boolean>(false)
  const formRef = useRef(null)
  const rulesRef = useRef<AlarmRuleHandle>()
  const selectInstanceRef = useRef<SelectInstanceHandel>()
  // 告警联系人&&回调
  const [userNotice, setUserNotice] = useState<ConcatProps[]>([])
  const [callback, setCallback] = useState<CallbackValueProp[]>([])
  // 编辑策略详情id
  const editPolidyId = _.get(params, 'policyId')
  // 获取产品ID
  const defaultProduct = _.get(params, 'productType')

  // 根据router 参数ID 获取详情
  const { value, loading } = useAsync(async () => {
    // 获取产品列表
    // '/monitor/?Action=DescribeCloudServiceMenu&Version=2021-01-01'
    const productData = await GetProductList()
    if (editPolidyId) {
      const detailData = await GetTacticsPolicyDetail({
        PolicyId: parseInt(editPolidyId)
      })
      let selectedInstances = []
      if (
        detailData?.data?.policy?.resourceBindType === 3 ||
        detailData?.data?.policy?.resourceBindType === 1
      ) {
        const res = await getSelectedInstance()
        selectedInstances = _.cloneDeep(res)
      }
      return {
        detailData: detailData?.data?.policy || {},
        productList: productData?.data?.productList || [],
        selectedInstances
      }
    } else {
      return {
        detailData: {},
        productList: productData?.data?.productList || [],
        selectedInstances: []
      }
    }
  }, [editPolidyId])

  // 获取策略下所选实例
  const getSelectedInstance = async () => {
    const data = await GetPolicyInstances({ PolicyId: editPolidyId, PageSize: 999 })
    if (data?.data?.resourceList?.length) {
      // setInstaneIdsTotal(data?.data?.totalCount || 0)
      return data?.data?.resourceList
    } else {
      // setInstaneIdsTotal(0)
      return []
    }
  }

  // 编辑详情数据 & 产品列表
  const { detailData, productList, selectedInstances } = value || {}

  // 编辑：设置初始值
  useEffect(() => {
    if (Array.isArray(productList)) {
      if (detailData?.policyName) {
        const {
          policyName,
          productType,
          alertGradingEnabled,
          triggerRules,
          resourceBindType,
          projectId,
          policyType,
          templateId,
          userNotice,
          urlNotice,
          urlNotices
        } = detailData
        // 告警联系人
        setUserNotice(
          userNotice?.map(item => {
            return {
              ContactID: item.contactId,
              ContactFlag: item.contactFlag,
              ContactChannels: handleWayToChannels(item.contactChannels || item.contactWay),
              ContactName: item.contactName
            }
          }) || []
        )
        // 告警回调
        setCallback(handleCallbackType(urlNotices || urlNotice) || [])
        // 设置策略名称
        policyName && setPolicyName(policyName)
        // 设置产品类型
        const chosedItem =
          Array.isArray(productList) && productList.find(i => i.productType === productType)
        setCurrentProduct(chosedItem)
        if (templateId) {
          setTrigger('template')
          setTemplate({ TemplateID: templateId })
          setAlertGrading(alertGradingEnabled || false)
        } else {
          // 告警分级
          setAlertGrading(alertGradingEnabled || false)
          // 设置告警规则
          triggerRules?.length &&
            setTriggerRules(
              triggerRules?.map(item => {
                const { itemKey, units, triggerValue, displayUnits, hierarchicalValue } = item
                const levelValue = {
                  Critical: {
                    Value: '',
                    Units: units,
                    DisplayUnits: displayUnits
                  },
                  Error: {
                    Value: triggerValue,
                    Units: units,
                    DisplayUnits: displayUnits
                  },
                  Warning: {
                    Value: '',
                    Units: units,
                    DisplayUnits: displayUnits
                  }
                }
                if (hierarchicalValue) {
                  Object.entries(hierarchicalValue).forEach(([key, item]) => {
                    const { Value, DisplayUnits, Units } = item as LevelValueItemProps
                    const value = handleMetricUnits(
                      productType,
                      itemKey,
                      Value,
                      Units,
                      DisplayUnits
                    )
                    levelValue[key] = {
                      Value: value + '',
                      Units: Units,
                      DisplayUnits: DisplayUnits
                    }
                  })
                }
                const calcTriggerValue = handleMetricUnits(
                  productType,
                  itemKey,
                  triggerValue,
                  units,
                  displayUnits
                )
                return {
                  ...item,
                  levelValue,
                  triggerValue: calcTriggerValue + ''
                }
              })
            )
        }
        // 设置通知对象
        if (resourceBindType !== undefined) {
          setResourceBindType(resourceBindType === 1 ? 3 : resourceBindType)
        }
        setInstanceIds(selectedInstances || [])
        projectId !== undefined && setProject(projectId)
        // 默认策略
        setDefaultPolict(policyType === 1 ? true : false)
      } else if (defaultProduct !== undefined) {
        // 设置产品类型
        const chosedItem =
          Array.isArray(productList) &&
          productList.find(i => i.productType === parseInt(defaultProduct))
        setProductDisabled(!!chosedItem)
        setCurrentProduct(chosedItem || undefined)
      }
    }
  }, [productList, detailData])

  const instanceChange = (type, value) => {
    if (type === 3) {
      setInstanceIds(value)
    } else if (type === 2) {
      setProject(value)
    } else if (type === 5) {
      setIPpackage(value.split('\n').filter(item => !!item))
    }
    setResourceBindType(type)
  }

  const toTacticsList = () => {
    history.push(`/monitor/alarmServer/rule/home`)
  }

  // 提交
  const submitParams = async event => {
    const valid = await formRef.current.validate()
    if (valid) {
      let rulesParams: any = []
      if (trigger === 'rule') {
        // 告警规则
        const rulesValid = await rulesRef?.current?.getTriggerRules(alertGrading)
        if (!rulesValid) {
          Message.error(_$('请正确填写告警规则'))
          return
        }
        if (!rulesValid?.length) {
          Message.error(_$('至少填写一条告警规则'))
          return
        }
        rulesParams = rulesValid.map(item => {
          const res = setItemSpacial(item.itemKey)
          const calc = {}
          if (thanLastPeriod.includes(item.compare)) {
            // 周期环比 单位为 %
            _.set(calc, 'DisplayUnits', '%')
          } else {
            _.set(calc, 'TriggerValue', item.triggerValue + '')
          }
          return {
            RuleId: item.ruleId,
            Compare: item.compare,
            EffectBT: item.effectBT,
            EffectET: item.effectET,
            Interval: item.interval,
            ItemKey: item.itemKey,
            ItemName: item.itemName,
            MaxCount: item.maxCount,
            Method: item.method || 'avg',
            Period: item.period,
            Points: item.points,
            TriggerValue: item.triggerValue,
            Units: item.units,
            DisplayUnits: item.displayUnits,
            HierarchicalValue: item.levelValue,
            ...calc,
            ...res
          }
        })
      } else if (trigger === 'template') {
        rulesParams =
          template?.TriggerRules?.map(item => {
            return {
              ...item,
              RuleId: undefined
            }
          }) || []
      }
      const params = {
        PolicyName: policyName,
        ProductType: currentProduct?.productType,
        ResourceBindType: resourceBindType,
        AlertGradingEnabled: alertGrading,
        TriggerRules: _.cloneDeep(rulesParams),
        UserNotice: userNotice,
        URLNotices: callback,
        PolicyType: defaultPolicy ? 1 : 0,
        InstanceIds: undefined,
        ProjectId: undefined,
        TemplateID: trigger === 'template' ? template?.TemplateID : 0
      }
      // 通知对象 自选实例
      if (resourceBindType === 3) {
        const instanceList = selectInstanceRef.current.getInstance()
        const unbindList = selectInstanceRef.current.getUnbindList()
        if (editPolidyId) {
          const InstanceIds = (instanceList as InstanceItem[]).map(item => item?.instanceId)
          const BindInstances = InstanceIds.filter(
            id => !selectedInstances.find(({ instanceId }) => instanceId === id)
          )
          _.set(params, 'BindInstances', BindInstances)
          _.set(params, 'UnBindInstances', unbindList)
        } else {
          _.set(
            params,
            'InstanceIds',
            (instanceList as InstanceItem[]).map(item => item?.instanceId)
          )
        }
      } else if (resourceBindType === 2) {
        // 项目
        _.set(params, 'ProjectId', project)
      } else if (resourceBindType === 5) {
        // 批量新建 弹性IP
        _.set(params, 'InstanceIds', IPpackage)
        _.set(params, 'ResourceBindType', 3)
      }
      // 修改策略function
      const modifyPolict = async () => {
        const result = await ModifyAlarmPolicy(params)
        if (result.code === 'Success') {
          Message.success(_$('编辑成功'))
          toTacticsList()
        }
      }
      if (editPolidyId) {
        _.set(params, 'PolicyId', parseInt(editPolidyId))
        // CDN自动解绑实例 提醒
        if (params.ProductType === 22 && (params as any).UnBindInstances?.length) {
          const find = (params as any).UnBindInstances.find(item =>
            needDrop.find(name => item.toLocaleLowerCase().indexOf(name.toLocaleLowerCase()) === -1)
          )
          if (find) {
            Dialog.confirm({
              content: `当前选择监控项不支持绑定${needDrop.join(
                '、'
              )}资源，提交后会自动解绑，是否继续提交？`
            }).then(() => {
              modifyPolict()
            })
          } else {
            modifyPolict()
          }
        } else {
          modifyPolict()
        }
      } else {
        const result = await CreatePolicy(params)
        if (result.code === 'Success') {
          Message.success(_$('新建成功'))
          toTacticsList()
        }
      }
    }
  }

  useEffect(() => {
    if (resourceBindType === 2) {
      setDefaultPolict(false)
    }
  }, [resourceBindType])

  // 判断是否支持电话
  const showPhone = useMemo(() => {
    if (alertGrading) {
      if (trigger === 'rule') {
        const find = triggerRules?.find(item => item.levelValue?.Critical?.Value)
        return !!find
      } else if (trigger === 'template') {
        const find = template?.TriggerRules?.find(item => item.HierarchicalValue?.Critical?.Value)
        return !!find
      } else {
        return false
      }
    }
    return false
  }, [alertGrading, trigger, triggerRules, template])

  return (
    <div className={className}>
      {!loading ? (
        <>
          <CustomPageContainer
            showBack
            title={editPolidyId ? policyName || '' : _$('新建告警策略')}
          >
            <Card type="none">
              <div className="rule_body">
                {/* 策略信息 */}
                <div className="select_position" style={{ paddingTop: '0px' }}>
                  <h1 className="first create_model_title">{_$('策略信息')}</h1>
                  {/* 基本信息 */}
                  <Form starOnRequired ref={formRef} labelWidth={100}>
                    <FormItem
                      label={_$('策略名称')}
                      value={policyName}
                      rules={{ required: true, userName: true }}
                      messages={{
                        required: _$('请输入策略名称')
                      }}
                    >
                      <Input
                        value={policyName}
                        width={500}
                        placeholder={_$('请输入策略名称')}
                        onChangeValue={value => setPolicyName(value)}
                      ></Input>
                    </FormItem>
                    <FormItem
                      label={_$('产品类型')}
                      value={currentProduct?.productType}
                      rules={{ required: true }}
                      messages={{
                        required: _$('请选择产品类型')
                      }}
                    >
                      <ProductGroupSelect
                        container=".select_position"
                        disabled={editPolidyId || productDisabled ? true : false}
                        value={currentProduct?.productType}
                        width={500}
                        onChange={value => {
                          if (currentProduct?.productType !== value) {
                            const chosedItem = productList.find(i => i.productType === value)
                            setTriggerRules([initRuleItem])
                            setTemplate(undefined)
                            setCurrentProduct(chosedItem)
                            setResourceBindType(3)
                          }
                        }}
                      />
                    </FormItem>
                    {currentProduct?.productType !== undefined &&
                    currentProduct?.productType !== 5 ? (
                      <>
                        <h1 className="create_model_title">{_$('告警规则')}</h1>
                        <FormItem
                          label={_$('触发条件')}
                          value={trigger}
                          rules={{ required: true }}
                          messages={{
                            required: _$('请选择触发条件')
                          }}
                        >
                          <Radio
                            name="trigger"
                            trueValue="template"
                            value={trigger}
                            onChangeValue={(value: any) => setTrigger(value)}
                          >
                            {_$('选择模版')}
                          </Radio>
                          <Radio
                            name="trigger"
                            trueValue="rule"
                            value={trigger}
                            onChangeValue={(value: any) => setTrigger(value)}
                          >
                            {_$('手动匹配')}
                          </Radio>
                        </FormItem>
                        {trigger === 'template' ? (
                          <SelectTemplate
                            type="threshold"
                            value={template?.TemplateID}
                            productType={currentProduct?.productType}
                            onChange={value => {
                              setTemplate(value)
                              setAlertGrading(!!value?.AlertGradingEnabled)
                            }}
                          />
                        ) : null}
                        {trigger === 'rule' ? (
                          <AlarmRule
                            ref={rulesRef}
                            productType={currentProduct?.productType}
                            triggerRules={triggerRules}
                            setTriggerRules={setTriggerRules}
                            showAlertGrading={true}
                            alertGrading={alertGrading}
                            setAlertGrading={setAlertGrading}
                          />
                        ) : null}
                      </>
                    ) : null}
                    {currentProduct?.productType === 5 ||
                    (currentProduct?.productType !== undefined && triggerRules?.[0]?.itemKey) ||
                    (trigger === 'template' && !!template?.TemplateID) ? (
                      <>
                        <h1 className="create_model_title">{_$('关联实例')}</h1>
                        <SelectInstance
                          ref={selectInstanceRef}
                          pageType="tacticsAlarm"
                          policyId={editPolidyId}
                          triggerRules={triggerRules}
                          productType={currentProduct?.productType + ''}
                          allInstance={false}
                          IPpackage={!editPolidyId && currentProduct?.productType === 4}
                          defaultRadioValue={resourceBindType}
                          defaultInstance={instanceIds}
                          // setInstaneIdsTotal={setInstaneIdsTotal}
                          // instanceIdsTotal={instanceIdsTotal}
                          defalutProject={project}
                          disabled={
                            detailData?.resourceBindType === 2 || detailData?.resourceBindType === 4
                          }
                          instanceGroup={false}
                          isGroupFilter={false}
                          projectDimens={!!currentProduct.iamProjectFlag}
                          projectDisabled={detailData?.resourceBindType !== undefined}
                          getSelectedInstaces={
                            detailData?.resourceBindType === 2 ? getSelectedInstance : undefined
                          }
                          selectContainer=".select_position"
                          onChange={instanceChange}
                        />
                      </>
                    ) : null}
                    <h1 className="create_model_title">
                      {_$('告警联系人')}
                      <Tooltip
                        hoverable
                        slotContent={
                          <>
                            <div>{_$('紧急（Critical）：邮件、短信、电话均会通知。')}</div>
                            <div>{_$('严重（Error）：邮件、短信通知。')}</div>
                            <div>{_$('警告（Warning）：仅邮件通知。')}</div>
                          </>
                        }
                      >
                        <Icon className="icontip ion-help-circled" />
                      </Tooltip>
                    </h1>
                    <div style={{ width: 600 }}>
                      <AlarmReciver
                        showSchedule={true}
                        showPhone={showPhone}
                        value={userNotice}
                        onChange={value => setUserNotice(value)}
                      />
                    </div>
                    <h1 className="create_model_title">
                      <AlarmCallBackTooltip />
                    </h1>
                    <div style={{ width: 600 }}>
                      <AlarmCallBack
                        showCallbackType={true}
                        value={callback}
                        onChange={value => setCallback(value)}
                      />
                    </div>

                    {resourceBindType !== 2 ? (
                      <>
                        <h1 className="create_model_title">{_$('默认策略')}</h1>
                        <div className="default-policy">
                          <p>{_$('设置默认策略')}：</p>
                          <Switch
                            disabled={editPolidyId && detailData?.enabled !== 0}
                            on={_$('是')}
                            off={_$('非')}
                            width="80"
                            value={defaultPolicy}
                            onChangeValue={v => setDefaultPolict(v)}
                          />
                          <p className="tip">
                            {_$(
                              '每类产品下只允许有一项默认策略。若当前产品下已有默认策略，开启后，之前的默认策略会变为“非默认”状态'
                            )}
                          </p>
                        </div>
                      </>
                    ) : null}
                  </Form>
                </div>
                <div className="bottom_action">
                  <Button onClick={event => submitParams(event)} type="primary">
                    {_$('确认')}
                  </Button>
                  <Button onClick={toTacticsList} type="default">
                    {_$('取消')}
                  </Button>
                </div>
              </div>
            </Card>
          </CustomPageContainer>
        </>
      ) : null}
      {/* 容器创建告警跳转Prometheus */}
      <RedirectPrometheus currentProduct={currentProduct} editPolicyId={editPolidyId} />
    </div>
  )
}
export default styled(MonitorCreate)`
  .rule_body {
    width: 100%;
    height: calc(100vh - 228px);
    overflow: auto;
    margin-bottom: 16px;
    .k-radio {
      margin-right: 8px;
    }
  }
  .select_position {
    position: relative;
    .create_model_title {
      padding: 16px 0;
      margin-top: 16px;
      position: relative;
      font-size: 16px;
      vertical-align: middle;
      font-weight: 700;
      border-top: 1px solid #f0f0f0;
    }
    .create_model_title.first {
      margin-top: 0;
      padding-top: 0;
      border: none;
    }
    .default-policy {
      display: flex;
      align-items: center;
      padding-bottom: 16px;
      p {
        margin: 0;
      }
      .tip {
        margin-left: 8px;
        color: #999;
      }
    }
    .k-dropdown-menu.metrci_select {
      height: 240px;
      .k-dropdown-item.k-active {
        background-color: #f3f5f6;
      }
      .k-select-option {
        height: 44px;
        .metric_option {
          padding: 2px 0;
          p {
            line-height: 20px;
            margin-bottom: 0;
            &.metric_key {
              color: #b0b8d7;
            }
          }
        }
      }
    }
  }
  .bottom_action {
    display: flex;
    justify-content: flex-end;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 64px;
    padding: 16px 0;
    background: #ffffff;
    padding-right: 16px;
    z-index: 98;
    border-radius: 6px 6px 0 0;
    button {
      font-size: 14px;
      margin-left: 8px;
    }
  }
`
